import React, { useState } from 'react'
import styles from './styles.module.scss'

import { SaveValueInterface } from '../../../interfaces'
import { SignatureHearingLoss } from '../../formParts/signatureHearingLoss'
import { CompleteSigned } from '../../formParts/completSignedHearingLoss'

function HearingLossSignForm() {
    const [activeGroup, setActiveGroup] = useState('signature')

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
    }

    const saveFieldValue = (_dataToSave: SaveValueInterface) => {
        return { success: true, error: '' }
    }

    const activeGroupAssignment = async (group: string) => {
        setActiveGroup(group)
        window.scrollTo(0, 0)
    }

    return (
        <div className={styles.formContainer}>
            <form onSubmit={handleSubmit}>
                <div>
                    <SignatureHearingLoss
                        saveValueFunct={saveFieldValue}
                        isActive={activeGroup}
                        assignGroup={activeGroupAssignment}
                    />
                    <CompleteSigned
                        isActive={activeGroup}
                        saveValueFunct={saveFieldValue}
                        assignGroup={activeGroupAssignment}
                    />
                </div>
            </form>
        </div>
    )
}

export default HearingLossSignForm
